/**
 * @file Gate d'affichage conditionnel des actions du panel admin.
 * @module packages.common.guards.AdminGate
 *
 * Masque son contenu si l'utilisateur n'a pas l'accès requis. À poser sur
 * toute action « cross-page » : la règle est qu'une action est gatée par la
 * section qui possède l'ENDPOINT qu'elle appelle, pas par la page où elle
 * s'affiche (ex. bouton « Attribuer un abonnement » dans la page Comptes →
 * section subscriptions).
 *
 * Le backend reste l'autorité (requireAdminSection) : ce gate évite
 * uniquement d'afficher des actions vouées au 403 ou des listes vides.
 *
 * Usage :
 *   <AdminGate section="subscriptions">…affiché si section accordée…</AdminGate>
 *   <AdminGate section="companies" mode="manage">…si accès en gestion…</AdminGate>
 *   <AdminGate superAdminOnly>…réservé super admin…</AdminGate>
 */

import PropTypes from 'prop-types';
import {usePermissions} from 'packages/common/hooks/session';

export default function AdminGate({section, mode = 'read', superAdminOnly = false, children}) {
  const {hasAdminSection, canManageSection, isSuperAdmin} = usePermissions();

  let allowed;
  if (superAdminOnly) {
    allowed = isSuperAdmin;
  } else if (mode === 'manage') {
    allowed = canManageSection(section);
  } else {
    allowed = hasAdminSection(section);
  }

  if (!allowed) return null;

  return <>{children}</>;
}

AdminGate.propTypes = {
  children: PropTypes.node,
  section: PropTypes.string,
  mode: PropTypes.oneOf(['read', 'manage']),
  superAdminOnly: PropTypes.bool,
};
